<template>
	<div data-component="deal-pack-action-list">
		<action-list
			:actions="getActionList"
			@actionClick="onActionClick"
		/>
		<portal
			to="modal"
			v-if="duplicateModalIsVisible"
		>
			<modal-inner
				size="sm"
				heading="Duplicate deal pack"
				@close="toggleDuplicateModalIsVisible"
			>
				<div class="duplicate-deal-pack-modal">
					<actions
						:actions="getDuplicateModalActions"
						@actionClick="onActionClick"
						:isWaiting="isWaiting"
					/>
				</div>
			</modal-inner>
		</portal>
		<portal
			to="modal"
			v-if="addStudentModalIsVisible"
		>
			<modal-inner
				@close="toggleAddStudentModalIsVisible"
				heading="Add a student"
			>
				<add-student-modal />
			</modal-inner>
		</portal>
	</div>
</template>

<script>

	import ActionList          from '@/components/ui/ActionList';
	import ModalInner          from '@/components/ui/modal/ModalInner';
	import AddStudentModal     from '@/components/dealPacks/AddStudentModal';
	import Actions             from '@/components/ui/Actions';
	import actionClick         from '@/mixins/actionClick';
	import routeParams         from '@/mixins/routeParams';
	import invalidFormMessage  from '@/mixins/invalidFormMessage';
	import api                 from '@/services/api';

	export default {
		components: {
			ActionList,
			ModalInner,
			AddStudentModal,
			Actions
		},
		mixins: [actionClick, routeParams, invalidFormMessage],
		props: {
			dealPack: {
				type: Object,
				default: undefined
			}
		},
		data: () => ({
			isWaiting: undefined,
			duplicateModalIsVisible: false,
			addStudentModalIsVisible: false
		}),
		computed: {
			getShowEditDealPack () {
				if (this.getContext === 'dealStore' ||
						this.getContext === 'myDeals') {
					return false;
				}
				return true;
			},
			getShowEditDeals () {
				return this.getContext === 'teaching';
			},
			getShowDuplicateDealPack () {
				return this.getContext === 'teaching';
			},
			getShowAddStudent () {
				return this.getContext === 'admin';
			},
			getDuplicateModalActions () {
				return {
					primary: [
						{
							text: 'Duplicate',
							actionId: 'duplicateDealPack'
						}
					],
					secondary: [
						{
							text: 'Cancel',
							actionId: 'toggleDuplicateModalIsVisible'
						}
					]
				};
			},
			getActionList () {
				return [
					(this.getShowEditDealPack ?
						{
							text: 'Edit Deal Pack',
							route: `/${this.getContextSlug}/deal-packs/${this.getDealPackId}/edit`
						} : false
					),
					(this.getShowEditDeals ?
						{
							text: 'Edit Deals',
							route: `/${this.getContextSlug}/deal-packs/${this.getDealPackId}/deals`
						} : false
					),
					(this.getShowEditDealPack ?
						{
							text: 'View Students',
							route: `/${this.getContextSlug}/deal-packs/${this.getDealPackId}/students`
						} : false
					),
					(this.getShowDuplicateDealPack ?
						{
							text: 'Duplicate',
							actionId: 'toggleDuplicateModalIsVisible'
						} : false
					),
					(this.getShowAddStudent ?
						{
							text: 'Add student',
							actionId: 'toggleAddStudentModalIsVisible'
						} : false
					)
				].filter(Boolean);
			}
		},
		methods: {
			toggleDuplicateModalIsVisible () {
				this.duplicateModalIsVisible = !this.duplicateModalIsVisible;
			},
			toggleAddStudentModalIsVisible () {
				this.addStudentModalIsVisible = !this.addStudentModalIsVisible;
			},
			async duplicateDealPack () {
				this.isWaiting = 'duplicateDealPack';
				const response = await api.teaching.duplicateDealPackById({
					dealPackId: this.dealPack.id
				});
				if (!response?.id) {
					this.isWaiting = undefined;
					return;
				}
				this.isWaiting = undefined;
				await this.$router.push(`/teaching/deal-packs/${response.id}`);
				this.$store.commit('ui/showNotification', {
					notification: 'The deal pack has been duplicated'
				});
			}
		}
	};

</script>

<style lang="scss" scoped>
	[data-component='deal-pack-action-list'] {
    margin-bottom: 36px;

    [data-component=action-list] {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
	}

	.duplicate-deal-pack-modal {
		::v-deep [data-component="actions"] {
			padding: 0;
		}
	}
</style>
